import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, enableProdMode, viewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, NavigationError } from '@angular/router';
import { PaymentService } from './payment.service';
import { AuthenticationService } from './authentication/auth.service';
import { LazyLoadErrorModalComponent } from './lazy-load-error-modal/lazy-load-error-modal.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'Dedicaid';
  
  private readonly lazyLoadErrorModal = viewChild(LazyLoadErrorModalComponent);

  constructor(
    @Inject(DOCUMENT) private doc: any,
    private router: Router,
    auth: AuthenticationService,
    paymentService: PaymentService
  ) {
    paymentService.getProviderConfig('stripe').toPromise().then(stripeConfig => {
      if (typeof stripeConfig === 'object' && stripeConfig['publicKey']) {
        this.enableStripe();
      }
    });

    auth.getFrontendConfig().then(config => {
      if (config.productionMode)
        enableProdMode();
    });
  }

  ngOnInit(): void {
    // Subscribe to router events to detect lazy-load failures
    this.router.events
      .subscribe(event => {
        if (event['error']) {
          if (this.isChunkLoadError(event['error'])) {
            this.lazyLoadErrorModal()?.open();
            console.error('Lazy-load module failed:', event);
          }
        }
      });
  }

  private isChunkLoadError(error: any): boolean {
    // Detect chunk load errors (typically 404 or network issues)
    const errorString = error?.toString() || '';
    const errorMessage = error?.message || '';
    
    return (
      errorString.includes('ChunkLoadError') ||
      errorString.includes('Loading chunk') ||
      errorMessage.includes('ChunkLoadError') ||
      errorMessage.includes('Loading chunk') ||
      errorMessage.includes('Failed to fetch dynamically imported module') ||
      error?.name === 'ChunkLoadError' ||
      (error?.status === 404)
    );
  }

  private enableStripe() {
    const s = this.doc.createElement('script');

    s.defer = true;
    s.async = true;
    s.setAttribute("crossorigin", "anonymous");
    s.src = "https://js.stripe.com/v3/";

    const head = this.doc.getElementsByTagName('head')[0];
    head.appendChild(s);
  }
}
